import { createContext } from "react";

export interface PWAContextType {
    isOnline: boolean
    isInstalled: boolean
    canInstall: boolean
    updateAvailable: boolean
    serviceWorkerReady: boolean
    install: () => Promise<void>
    applyUpdate: () => void
    syncStatus: 'idle' | 'syncing'| 'error'
    queueLength: number
}

export const PWAContext = createContext<PWAContextType | null>(null)